import React from "react";
import { Box } from "native-base";
import { useNavigation } from "@react-navigation/core";
import { ContainerBaseCenter, FooterBase } from "../../../styles/default";
import { SuccessContainer } from "./styles";
import { TextPage, TitlePage } from "../../../styles/typograph";
import { Text, View } from "react-native";
import { Feather } from "@expo/vector-icons";
import { ButtonBase } from "../../../components/buttons";
import { CARDS, CARDS_PASSWORD, LOGIN } from "../../../constants/routes";

const CardSuccess = ({ navigation }) => {
  const { navigate } = useNavigation();

  return (
    <Box style={{ flex: 1, backgroundColor: "#FF671D" }} safeArea>
      <ContainerBaseCenter>
        <SuccessContainer>
          <View style={{ justifyContent: "center", alignItems: "center" }}>
            <Feather name="check-circle" size={40} color="white" />
          </View>
          <TitlePage
            style={{ marginBottom: 10, marginTop: 15 }}
            color="white"
            center
          >
            Dígitos validados com sucesso
          </TitlePage>
          <TextPage color="white" center style={{ marginBottom: 10 }}>
            Agora será necessário criar uma senha para o seu cartão.
          </TextPage>
        </SuccessContainer>
      </ContainerBaseCenter>
      <FooterBase>
        <ButtonBase
          color="outline-white"
          title="CRIAR SENHA DO CARTÃO"
          onPress={() => navigate(CARDS_PASSWORD)}
        />
      </FooterBase>
    </Box>
  );
};

export default CardSuccess;
